"use client";

import styles from "./Navbar.module.css";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { trackPageView } from "../../utils/googleAnalytics";
import { useSearchParams } from "next/navigation";


const Navbar = () => {
  const path = usePathname();
  const searchParams = useSearchParams();
  const showNavBar = searchParams.get("showNavBar");
  const isHome = path === "/";
  const isPricing = path === "/subscribe-now";
  const isArticles = path === "/articles";
  const isNews = path === "/news";
  const isFAQ = path === "/faq";
  const isCreatingPlan = path === "/preferencfes/creating-plan";
  const noNavbarPaths = [
    "/subscription",
    "/checkout",
    "/payment/success",
    "/redeem",
    "/redeem/upgrade",
    "/redeem/success",
    "/casecandy",
    "/get-started",
    "/subscribe-now",
    "/subscribe-now-success",
    "/subscribe-upgrade",
    "/subscribe-upgrade-success",
    "/mecenat",
  ];


  const noNavbar = (noNavbarPaths.includes(path) || path.startsWith('/promotions')) && !showNavBar;
  const router = useRouter();

  useEffect(() => {
    trackPageView(window.location.href, path);
  }, []);

  return (
    <nav
      className={`${noNavbar ? 'hidden md:hidden' : ''} bg-black pt-5 md:pb-5 pl-0 md:pl-[50px] fullfont-tradeGothicCondensedBold`}
    >

      {!isCreatingPlan && (
        <div className="flex items-center w-full">
          {/* Logo */}
          <div className={`${styles.logo} flex items-center ml-0 md:ml-10`}>
            <a href="/">
              {/* Desktop Logo - Visible on md+ screens */}
              <Image
                width={60}
                height={60}
                src="/images/logo_inverted.webp"
                alt="logo"
                loading="eager"
                className="hidden md:flex"
              />

              {/* Mobile Logo - Visible on small screens */}
              <Image
                width={40}
                height={40}
                src="/images/logo_inverted.webp"
                alt="logo"
                loading="eager"
                className="flex md:hidden ml-3"
              />
            </a>


            {/* Home and Get Started Links (next to the logo, not far-right) */}
            <div className="ml-7 md:ml-10 flex gap-x-[16px] text-white">
              <a
                href="/"
                className={`text-[16px] text-white md:mr-4 font-medium pb-1 ${isHome ? 'border-b-2 border-[#ecbf61] ' : 'hover:text-gray-200'
                  }`}
              >
                HOME
              </a>
              <a
                href="/subscribe-now?showNavBar=true"
                className={`text-[16px] text-white md:mr-4 font-medium pb-1 ${isPricing ? 'border-b-2 border-[#ecbf61]' : 'hover:text-gray-200'
                  }`}
              >
                PLANS
              </a>
              <a
                href="/articles"
                className={`text-[16px] text-white  md:mr-4 font-medium pb-1 ${isArticles ? 'border-b-2 border-[#ecbf61]' : 'hover:text-gray-200'
                  }`}
              >
                ARTICLES
              </a>
                            <a
                href="/news"
                className={`text-[16px] text-white  md:mr-4 font-medium pb-1 ${isNews ? 'border-b-2 border-[#ecbf61]' : 'hover:text-gray-200'
                  }`}
              >
                NEWS
              </a>
              <a
                href="/faq"
                className={`text-[16px] text-white font-medium pb-1 ${isFAQ ? 'border-b-2 border-[#ecbf61]' : 'hover:text-gray-200'
                  }`}
              >
                FAQ
              </a>

            </div>

          </div>

        </div>
      )}
    </nav>
  );
};

export default Navbar;
